import React from 'react';

import BackgroundImage from '../../BackgroundImage';
import { SCHOOL_TYPES } from '../../../utils/constants';
import StatsigLink from '../../Links/StatsigLink';
import { useStatsig } from '../../hooks/useStatsig';
import config from '../../../../config';

const FeaturedSchoolCard = (props) => {
    const { onClick, overlayPercent, schoolClub, 'data-testid': dataTestId } = props;
    const { id, gender, clubImages, school, location, sanctioned } = schoolClub;
    const { displayName, rosterCount, type } = school || {};
    const hasBackgroundImage = () => {
        return !!(clubImages.default || clubImages.dashboard.oneX);
    };
    const isCollege = type === SCHOOL_TYPES.COLLEGE;
    const isHighSchool = type === SCHOOL_TYPES.HIGH_SCHOOL;
    const { featureGates } = useStatsig();

    const descriptionItems = [];
    if (isHighSchool) {
        if (gender === 'Male') {
            descriptionItems.push('Boys');
        }
        if (gender === 'Female') {
            descriptionItems.push('Girls');
        }
    }
    if (isCollege) {
        if (gender === 'Male') {
            descriptionItems.push('Men\'s');
        }
        if (gender === 'Female') {
            descriptionItems.push('Women\'s');
        }
    }

    if (location?.display) {
        descriptionItems.push(location.display);
    }
    if (rosterCount) {
        descriptionItems.push(`${rosterCount} roster`);
    }
    const description = descriptionItems.join(' \u00B7 ');

    return (
        <StatsigLink
            gate={featureGates.CLUB_LINKS_REDIRECT}
            enabledTo={`${config.nextAppHost}/${isCollege ? 'college' : 'high-school'}/${id}`}
            disabledTo={`/${isCollege ? 'colleges' : 'schools'}/${id}`}
            onClick={onClick}
        >
            <div className={`utr-card club-card club-card-featured ${hasBackgroundImage() ? 'has-background-image' : ''}`}>
                <div className={`card-view`}>
                    <BackgroundImage
                        baseUrl={'/v1/club/'}
                        defaultImage={''}
                        images={clubImages}
                        imageType={'dashboard'}
                        backgroundOverlay={hasBackgroundImage()}
                        overlayPercent={overlayPercent}
                    >
                        <div className="club-details">
                            <div className="d-flex align-self-stretch">
                                <div className="flex-grow">
                                    <div className="tag-container">
                                        <div className={`tag tag-featured tag-sm mr8`} data-testid={dataTestId && `${dataTestId}.featured-tag`}>Featured</div>
                                    </div>
                                </div>
                                {/* menuOptions && menuOptions.length > 0 && (
                                    <PopOverMenu
                                        horizontalEllipsis={false}
                                        popOverMenuClass="mt4 popover-ellipsis"
                                        menuItems={menuOptions}
                                        onSelected={menuOnSelected}
                                    />
                                ) */}
                            </div>
                            <div className="empty-div" />
                            <div className={`name show-ellipsis`} data-testid={dataTestId && `${dataTestId}.name`}>
                                {displayName} <span className={`${sanctioned ? 'sanctioned' : ''}`} />
                            </div>
                            <div className="details show-ellipsis" data-testid={dataTestId && `${dataTestId}.details`}>{description}</div>
                        </div>
                    </BackgroundImage>
                </div>
            </div>
        </StatsigLink>
    );
};

FeaturedSchoolCard.defaultProps = {
    'data-testid': null,
};

export default FeaturedSchoolCard;
